import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Target, ShieldCheck, Rocket, HeartHandshake } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  {
    title: "AI Strategy & Vision",
    tagline: "Turn AI from buzzword to boardroom strategy",
    description: "Defining your AI transformation vision, objectives, and a clear strategic roadmap.",
    icon: Target,
    link: "/services#strategy",
    duration: "4-6 weeks",
    complexity: "Strategic"
  },
  {
    title: "AI Governance & Compliance",
    tagline: "Mitigate risk while maximizing AI innovation",
    description: "Developing robust AI governance frameworks and ensuring alignment with the EU AI Act.",
    icon: ShieldCheck,
    link: "/services#governance",
    duration: "6-8 weeks",
    complexity: "Complex"
  },
  {
    title: "AI Implementation Leadership",
    tagline: "Move from pilots to production at scale",
    description: "Leading programs and projects to effectively integrate AI solutions.",
    icon: Rocket,
    link: "/services#implementation",
    duration: "3-6 months",
    complexity: "Technical"
  },
  {
    title: "Ongoing AI Support & Coaching",
    tagline: "Build lasting AI capabilities within your team",
    description: "Providing continuous guidance for your AI team and key stakeholders.",
    icon: HeartHandshake,
    link: "/services#support",
    duration: "Ongoing",
    complexity: "Flexible"
  }
];

const Services = () => {
  return (
    <section className="py-20 px-6 bg-background">
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-4xl md:text-5xl font-bold text-foreground text-center mb-12">
          Services
        </h2>
        
        <div className="grid md:grid-cols-2 gap-6">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card 
                key={index}
                className="group transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_10px_40px_rgba(0,198,255,0.2)] border-border/50 hover:border-primary/30"
              >
                <CardHeader>
                  <div className="flex items-start justify-between gap-4 mb-4">
                    <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-primary/10 group-hover:bg-primary/20 transition-colors">
                      <IconComponent className="w-7 h-7 text-primary" />
                    </div>
                    <div className="flex flex-wrap gap-2">
                      <Badge variant="secondary" className="text-xs">
                        {service.duration}
                      </Badge>
                      <Badge variant="outline" className="text-xs">
                        {service.complexity}
                      </Badge>
                    </div>
                  </div>
                  
                  <CardTitle className="text-xl md:text-2xl">
                    {service.title}
                  </CardTitle>
                  <p className="text-sm font-semibold text-primary mt-2">
                    {service.tagline}
                  </p>
                  <CardDescription className="text-base mt-3">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                
                <CardContent>
                  <Link 
                    to={service.link}
                    className="inline-flex items-center text-primary hover:text-primary/80 transition-colors font-medium"
                  >
                    Learn more about {service.title}
                    <svg 
                      className="ml-1 w-4 h-4" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </Link>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
